import React from 'react'
import Table from '@/components/table/Table'
import Row from '@/components/table/Row'
import PopupDialog from '@/components/popupDialog/PopupDialog'
import DownloadButton from '@/components/buttons/DownloadButton'
import {
  useLazyGetSchemaQuery,
  useLazyGetFileDownloadLinkQuery,
  ICreatedSchema,
} from '@/store/apis/schemas'
import { useTranslation } from 'react-i18next'
import { format, parseISO } from 'date-fns'
import { useParams } from 'react-router-dom'

interface IState {
  selectedPopup?: 'PREVIEW_PDF'
  selectedSchema?: ICreatedSchema
}

const FinishedSchemas: React.FC = () => {
  const { t } = useTranslation()
  const urlParams = useParams()
  const [getSchemaQuery, { data: schemaData, isFetching: isGettingSchema }] =
    useLazyGetSchemaQuery()
  const [
    getFileDonwloadLinkQuery,
    { data: downloadLink, isFetching: isGettingDownloadLink },
  ] = useLazyGetFileDownloadLinkQuery()
  const [state, setState] = React.useState<IState>({})
  const schemaId = Number(urlParams.schemaId)

  React.useEffect(() => {
    getSchemaQuery({ id: schemaId })
  }, [getSchemaQuery, schemaId])

  const { selectedPopup, selectedSchema } = state

  return (
    <>
      <Table
        headerLabels={[
          t('headers.name'),
          t('headers.startDate'),
          t('headers.endDate'),
        ]}
        isLoading={isGettingSchema}
        noButtons
      >
        {schemaData?.schema.createdSchemas.map((createdSchema, index) => (
          <Row
            key={index}
            columns={{
              normal: [
                createdSchema.name,
                format(parseISO(createdSchema.startDate), 'yyyy-MM-dd'),
                format(parseISO(createdSchema.endDate), 'yyyy-MM-dd'),
              ],
            }}
            onClick={() => {
              getFileDonwloadLinkQuery({
                id: schemaId,
                path: `created-schemas/${createdSchema.name}`,
              })
              setState({
                ...state,
                selectedPopup: 'PREVIEW_PDF',
                selectedSchema: createdSchema,
              })
            }}
          />
        ))}
      </Table>
      {selectedSchema && (
        <PopupDialog
          isOpen={selectedPopup === 'PREVIEW_PDF'}
          title={
            <>
              {t('popups.previewSchema')}: <b>{selectedSchema.name}</b>
            </>
          }
          content={
            <>
              <iframe src={downloadLink?.link} width="100%" height="100%" />
            </>
          }
          fullScreen
          disableMaxWidth
          isLoading={isGettingDownloadLink}
          confirmButton={
            <DownloadButton
              downloadLink={downloadLink?.link}
              isLoading={isGettingDownloadLink}
            />
          }
          onClose={() =>
            setState({
              ...state,
              selectedPopup: undefined,
              selectedSchema: undefined,
            })
          }
        />
      )}
    </>
  )
}

export default FinishedSchemas
